import React, { memo, MouseEvent, ReactNode, useCallback } from 'react'
import cn from 'classnames'
import noop from 'lodash/noop'

import { BaseOptionType, IOptionProps } from './types'

import s from './OptionTemplate.module.less'

export interface IOptionTemplateProps<Option extends BaseOptionType> extends IOptionProps<Option> {
  children: ReactNode
}

const OptionTemplateNoMemo = <Option extends BaseOptionType>({
  hoverOptionRef,
  className,
  children,
  value,
  index = -1,
  isMobile,
  isSelected,
  isHovered = false,
  onClick = noop,
  onSetOptionHoverIndex = noop
}: IOptionTemplateProps<Option>) => {
  const handleSetHoverIndex = useCallback(() => {
    if (!isHovered) {
      onSetOptionHoverIndex(index)
    }
  }, [index, isHovered, onSetOptionHoverIndex])

  const handleSelectOption = useCallback(
    (event: MouseEvent) => {
      onClick(value, event)
    },
    [value, onClick]
  )

  return (
    <li
      ref={hoverOptionRef}
      data-name="select-option"
      onClick={handleSelectOption}
      onMouseMove={handleSetHoverIndex}
      className={cn(
        s.option,
        { [s.option_mobile]: isMobile },
        { [s.option_selected]: isSelected },
        { [s.option_hovered]: isMobile ? false : isHovered },
        className
      )}
    >
      {children}
    </li>
  )
}

export const OptionTemplate = memo(OptionTemplateNoMemo) as typeof OptionTemplateNoMemo
